import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { dateFormatter, infoFormatterIntl } from '../../../../utils/formatters';

export default function InsuranceView({
  data = {}, labelPrefix = '', hideSeries = false, formMeta, prefix = '',
}) {
  const {
    insurer = '',
    insurance_contract_series = '',
    insurance_contract_number = '',
    insurance_contract_effective_date = '',
    insurance_contract_expiration_date = '',
  } = data || {};
  return (
    <>
      <Row className="row-cols-1">
        {infoFormatterIntl(`${labelPrefix}insurer`, insurer, formMeta, `${prefix}insurer`)}
      </Row>
      <Row className="row-cols-2">
        {!hideSeries ? infoFormatterIntl(`${labelPrefix}insurance_contract_series`, insurance_contract_series, formMeta, `${prefix}insurance_contract_series`) : null}
        {infoFormatterIntl(`${labelPrefix}insurance_contract_number`, insurance_contract_number, formMeta, `${prefix}insurance_contract_number`)}
      </Row>
      <Row className="row-cols-2">
        {infoFormatterIntl(`${labelPrefix}insurance_contract_effective_date`, dateFormatter(insurance_contract_effective_date), formMeta, `${prefix}insurance_contract_effective_date`)}
        {infoFormatterIntl(`${labelPrefix}insurance_contract_expiration_date`, dateFormatter(insurance_contract_expiration_date), formMeta, `${prefix}insurance_contract_expiration_date`)}
      </Row>
    </>
  );
}
